import React, { useEffect } from "react";
import { withRouter } from "react-router";
import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission";

function QbRedirect({ location }) {
  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const paramsObj = Object.fromEntries(url.entries());
    api.integrations.quickbooks
      .redirect(paramsObj)
      .then(() => SUCCESS)
      .catch(_e => {});
  }, []);

  return (
    <div>
      <div className="row">
        <div className="col-sm-6 col-sm-offset-3">
          <div className="panel panel-default">
            <div className="panel-body pointer">
              <div className="flex" style={{ textAlign: "center" }}>
                <div>
                  <h2>Integrations</h2>
                  <img
                    src="https://info-trader-assets.s3.us-east-2.amazonaws.com/logos/quickbooks-logo.png"
                    alt="quickbooks"
                    height="50px"
                  />

                  <p style={{ marginTop: 10 }}>
                    <span className="fa fa-check" />&nbsp;&nbsp;Successfully
                    Connected!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(QbRedirect);



// WEBPACK FOOTER //
// ./app/modules/Admin/Integrations/QbRedirect.jsx